import { inlineView, customElement } from 'aurelia-framework';

@inlineView('<template class="mdc-menu__selection-group"><slot></slot></template>')
@customElement('mdc-menu-selection-group')
export class MdcMenuSelectionGroup { }
